import React from "react";
import PropTypes from "prop-types";

const RocketIcon = ({
  width,
  height,
  className,
  color,
  stroke,
  strokeWidth,
  selected,
  ...props
}) => {
  const strokeColor = stroke && stroke !== "currentColor" ? stroke : color || "#D946EF";

  return (
    <svg
      width={width || 40}
      height={height || 40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={selected ? 1 : undefined}
      className={className}
      {...props}
    >
      <path
        d="M20 25.0001V33.3334C22.4166 34.9501 25.05 32.4168 26.6666 30.0001C28.4666 27.3001 26.6666 21.6668 26.6666 21.6668M20 25.0001C22.3278 24.1141 24.5612 22.9975 26.6666 21.6668M20 25.0001L15 20.0001M26.6666 21.6668C35.3666 15.8334 36.6666 7.86676 36.6666 3.33342C29.2203 3.28724 22.2819 7.10335 18.3333 13.4168M15 20.0001C15.8869 17.6991 17.0036 15.4935 18.3333 13.4168M15 20.0001H6.66663C8.28329 22.4168 7.58329 14.9501 9.99996 13.3334C12.7 11.5334 18.3333 13.4168 18.3333 13.4168M7.49996 27.5001C4.99996 29.6001 4.16663 35.8334 4.16663 35.8334C4.16663 35.8334 10.4 35.0001 12.5 32.5001C13.6833 31.1001 13.6666 28.9501 12.35 27.6501C11.0085 26.3697 8.91801 26.305 7.49996 27.5001Z"
        stroke={strokeColor}
        strokeWidth={strokeWidth || "3.33333"}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

RocketIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  color: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selected: PropTypes.bool,
};

RocketIcon.defaultProps = {
  width: undefined,
  height: undefined,
  className: "",
  color: undefined,
  stroke: undefined,
  strokeWidth: undefined,
  selected: false,
};

export default RocketIcon;
